module.exports = (s, d = document) => Array.prototype.slice.call(d.querySelectorAll(s));